import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "PBLoader flex items-center justify-center flex-col w-[140px] h-[140px] mx-auto"
};
export function render(_ctx, _cache) {
  var _component_PBIcon = _resolveComponent("PBIcon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_PBIcon, {
    name: "bequant",
    w: 36,
    h: 36,
    "class": "animate-[spinner_1.2s_linear_infinite]"
  }), _cache[0] || (_cache[0] = _createElementVNode("p", {
    "class": "mt-lg text-lg font-semibold"
  }, " Loading... ", -1))]);
}